import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pop_up applicant_chk com_pop" }
const _hoisted_2 = { class: "pop_tit _flex" }
const _hoisted_3 = { class: "sch_condition_wrap" }
const _hoisted_4 = { class: "left _column _flex" }
const _hoisted_5 = { class: "date_wrap" }
const _hoisted_6 = {
  key: 0,
  class: "state_tag"
}
const _hoisted_7 = {
  key: 1,
  class: "state_tag waiting"
}
const _hoisted_8 = {
  key: 2,
  class: "state_tag finish"
}
const _hoisted_9 = { class: "collection_period" }
const _hoisted_10 = { class: "end_point" }
const _hoisted_11 = {
  key: 3,
  class: "activity_duration"
}
const _hoisted_12 = {
  class: "sch_condition_wrap",
  style: {"border-bottom":"1px solid #d9d9d9","padding-bottom":"10px"}
}
const _hoisted_13 = { class: "left" }
const _hoisted_14 = ["textContent"]
const _hoisted_15 = { class: "right" }
const _hoisted_16 = { class: "custom_scroll" }
const _hoisted_17 = { class: "areaAnswer" }
const _hoisted_18 = ["textContent"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "radio_wrap cnt p_5" }
const _hoisted_21 = ["for"]
const _hoisted_22 = ["id", "checked"]
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "checkbox_wrap cnt p_5" }
const _hoisted_26 = ["for"]
const _hoisted_27 = ["id", "checked"]
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = {
  key: 1,
  innerHTML: '신청자가 작성한 답이 없습니다.'
}
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { class: "areaSign" }
const _hoisted_33 = { style: {"display":"block"} }
const _hoisted_34 = {
  type: "button",
  class: "down_btn icon_wrap"
}
const _hoisted_35 = ["src"]
const _hoisted_36 = { class: "_flex _center btn_wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalDefault = _resolveComponent("ModalDefault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "pop_up_layer com_pop",
      style: {"display":"block"},
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", null, _toDisplayString($setup.state.boardItem.title), 1),
        _createElementVNode("button", {
          class: "close_btn icon_wrap",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
        }, [...(_cache[7] || (_cache[7] = [
          _createElementVNode("img", {
            src: "img/close.png",
            alt: "닫기"
          }, null, -1)
        ]))])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            ($setup.state.boardItem.state == 2)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "진행중"))
              : ($setup.state.boardItem.state == 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "대기중"))
                : (_openBlock(), _createElementBlock("span", _hoisted_8, "마감")),
            _createElementVNode("div", _hoisted_9, [
              _cache[8] || (_cache[8] = _createElementVNode("span", null, [
                _createElementVNode("img", {
                  src: "img/time_icon.png",
                  alt: ""
                }),
                _createTextVNode(" 모집기간 ")
              ], -1)),
              _createElementVNode("span", null, _toDisplayString($setup.CommonUtils.dateFormatYY(new Date($setup.state.boardItem.recruitStartDate), ".")), 1),
              _cache[9] || (_cache[9] = _createElementVNode("em", null, "-", -1)),
              _createElementVNode("span", null, _toDisplayString($setup.CommonUtils.dateFormatYY(new Date($setup.state.boardItem.recruitEndDate), ".")), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[10] || (_cache[10] = _createElementVNode("span", null, [
                _createElementVNode("img", {
                  src: "img/time_icon.png",
                  alt: ""
                }),
                _createTextVNode(" 신청종료일 ")
              ], -1)),
              _createElementVNode("span", null, _toDisplayString($setup.CommonUtils.dateFormatYY(new Date($setup.state.boardItem.applyDate), ".")), 1)
            ]),
            ($setup.state.boardItem.activeStartDate && $setup.state.boardItem.activeEndDate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _cache[11] || (_cache[11] = _createElementVNode("span", null, [
                    _createElementVNode("img", {
                      src: "img/cal_icon.png",
                      alt: ""
                    }),
                    _createTextVNode(" 활동기간 ")
                  ], -1)),
                  _createElementVNode("span", null, _toDisplayString($setup.CommonUtils.dateFormatYY(new Date($setup.state.boardItem.activeStartDate), ".")), 1),
                  _cache[12] || (_cache[12] = _createElementVNode("em", null, "-", -1)),
                  _createElementVNode("span", null, _toDisplayString($setup.CommonUtils.dateFormatYY(new Date($setup.state.boardItem.activeEndDate), ".")), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _cache[13] || (_cache[13] = _createElementVNode("label", null, "신청자", -1)),
          _createElementVNode("p", {
            textContent: _toDisplayString($setup.state.item.name)
          }, null, 8, _hoisted_14)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _cache[14] || (_cache[14] = _createElementVNode("label", null, "선발인원", -1)),
          _createElementVNode("p", null, _toDisplayString($setup.state.boardItem.cntApply) + "/" + _toDisplayString($setup.state.boardItem.pickCnt ? $setup.state.boardItem.pickCnt : 0), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("ul", _hoisted_17, [
          ($setup.state.list.length > 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.state.list, (item, idx) => {
                return (_openBlock(), _createElementBlock("li", { key: idx }, [
                  _createElementVNode("p", {
                    textContent: _toDisplayString(idx + 1 + '. ' + item.title)
                  }, null, 8, _hoisted_18),
                  (item.type !== 3)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (item.type === 1)
                          ? (_openBlock(), _createElementBlock("ul", _hoisted_19, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.caseList, (answer) => {
                                return (_openBlock(), _createElementBlock("li", _hoisted_20, [
                                  _createElementVNode("label", {
                                    for: 'radio_' + item.idx + '_' + answer.idx
                                  }, [
                                    _createElementVNode("input", {
                                      type: "radio",
                                      id: 'radio_' + item.idx + '_' + answer.idx,
                                      checked: answer.isChecked,
                                      disabled: ""
                                    }, null, 8, _hoisted_22),
                                    _cache[15] || (_cache[15] = _createElementVNode("em", null, null, -1)),
                                    _createElementVNode("span", {
                                      innerHTML: answer.title
                                    }, null, 8, _hoisted_23)
                                  ], 8, _hoisted_21)
                                ]))
                              }), 256))
                            ]))
                          : _createCommentVNode("", true),
                        (item.type === 2)
                          ? (_openBlock(), _createElementBlock("ul", _hoisted_24, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.caseList, (answer) => {
                                return (_openBlock(), _createElementBlock("li", _hoisted_25, [
                                  _createElementVNode("label", {
                                    for: 'chk_' + item.idx + '_' + answer.idx
                                  }, [
                                    _createElementVNode("input", {
                                      type: "checkbox",
                                      id: 'chk_' + item.idx + '_' + answer.idx,
                                      checked: answer.isChecked,
                                      disabled: ""
                                    }, null, 8, _hoisted_27),
                                    _cache[16] || (_cache[16] = _createElementVNode("em", null, null, -1)),
                                    _createElementVNode("span", {
                                      innerHTML: answer.title
                                    }, null, 8, _hoisted_28)
                                  ], 8, _hoisted_26)
                                ]))
                              }), 256))
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true),
                  (item.type === 3)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (item.answer)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              innerHTML: item.answer
                            }, null, 8, _hoisted_29))
                          : (_openBlock(), _createElementBlock("div", _hoisted_30))
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            : (_openBlock(), _createElementBlock("li", _hoisted_31, [...(_cache[17] || (_cache[17] = [
                _createElementVNode("div", {
                  class: "tb_subject",
                  style: {"text-align":"center","width":"100%"}
                }, "등록한 신청 양식이 없습니다.", -1)
              ]))])),
          _createElementVNode("li", _hoisted_32, [
            _createElementVNode("label", _hoisted_33, [
              _cache[18] || (_cache[18] = _createTextVNode(" 서명 ", -1)),
              _createElementVNode("button", _hoisted_34, [
                _createElementVNode("img", {
                  src: "img/download.png",
                  alt: "",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.exportSign($setup.state.item.sign)))
                })
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("img", {
                src: $setup.state.item.sign
              }, null, 8, _hoisted_35)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("button", {
          class: "submit_btn _130 _gray",
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.isSave(1)))
        }, "선발취소"),
        _createElementVNode("button", {
          class: "submit_btn _130 _main_blue",
          onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.isSave(3)))
        }, "임시저장"),
        _createElementVNode("button", {
          class: "submit_btn _130 _main_blue",
          onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.isSave(2)))
        }, "최종선발")
      ])
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: _cache[6] || (_cache[6] = ($event: any) => ($setup.state.isShowModal = false)),
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onCallback"]))
      : _createCommentVNode("", true)
  ], 64))
}